
<template>
  <div>
    <v-form v-model="nameValid">
      <v-row dense align="center" class="mb-3">
        <v-col cols="12" sm="3" class="font font--color_light"
          >Фамилия <span v-if="!second" class="profile-is-not-filled ml-sm-2"></span
        ></v-col>
        <v-col cols="12" sm="9">
          <MaskedTextField
            single-line
            :pattern="/[А-Яа-яёЁ-]/"
            :rules="[rule.required('Пожалуйста представьтесь')]"
            v-model="secondName"
            label="Фамилия"
          />
        </v-col>
      </v-row>

      <v-row class="mb-3" dense align="center">
        <v-col cols="12" sm="3" class="font font--color_light"
          >Имя <span v-if="!first" class="profile-is-not-filled ml-sm-2"></span
        ></v-col>
        <v-col cols="12" sm="9">
          <MaskedTextField
            single-line
            :pattern="/[А-Яа-яёЁ]/"
            :rules="[rule.required('Пожалуйста представьтесь')]"
            v-model="firstName"
            label="Имя"
          />
        </v-col>
      </v-row>

      <v-row class="mb-3" dense align="center">
        <v-col cols="12" sm="3" class="font font--color_light"
          >Отчество <span v-if="!middle" class="profile-is-not-filled ml-sm-2"></span
        ></v-col>
        <v-col cols="12" sm="9">
          <MaskedTextField
            single-line
            :pattern="/[\sА-Яа-яёЁ]/"
            :rules="[rule.required('Пожалуйста представьтесь')]"
            v-model="middleName"
            label="Отчество"
          />
        </v-col>
      </v-row>

      <v-row class="mb-3" dense align="center">
        <v-col cols="12" sm="3" class="font font--color_light">E-mail</v-col>
        <v-col cols="12" sm="9">
          <v-text-field
            hide-details
            single-line
            dense
            :rules="[rule.required('Ваш E-mail пожалуйста'), rule.email]"
            v-model="emailName"
            outlined
            label="E-mail"
          />
        </v-col>
      </v-row>

      <v-row class="mb-3" v-if="isNameOrEmailChanged">
        <v-col offset="0" offset-sm="3" cols="12">
          <v-btn class="mr-2" :disabled="!nameValid" color="primary" @click="updateName"> Сохранить </v-btn>
          <v-btn text @click="resetName">Отмена</v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-form ref="newPhoneForm" v-model="newPhoneValid" v-on:submit.prevent>
      <v-row class="mb-3" dense align="center">
        <v-col cols="12" sm="3" class="font font--color_light">Телефон</v-col>
        <v-col cols="12" sm="9">
          <v-text-field
            v-show="showChangePhoneForm"
            hide-details
            dense
            label="Новый номер"
            single-line
            :error="errdesc.length > 0"
            :error-messages="errdesc"
            outlined
            autofocus
            required
            :rules="[rule.required('Введите номер телефона'), rule.phone]"
            v-mask="'+7(9##) ###-##-##'"
            v-model="newphone"
            name="phone"
            type="text"
            @input="clearErrdesc"
          ></v-text-field>
          <v-text-field
            v-show="showConfirmCodeForm"
            dense
            hide-details
            :error="errdesc.length > 0"
            :error-messages="errdesc"
            single-line
            required
            outlined
            name="code"
            label="Код из смс"
            v-model="code"
            v-mask="'####'"
            type="text"
          ></v-text-field>
          <div v-show="!showConfirmCodeForm && !showChangePhoneForm">
            <a @click.prevent="openNewPhone" href="#" class="font">{{ formatPhone(phone) }}</a>
          </div>
        </v-col>
      </v-row>

      <v-row class="mb-3" dense align="center" v-if="showChangePhoneForm">
        <v-col offset="0" offset-sm="3" cols="12" sm="9">
          <v-text-field
            hide-details
            :rules="[rule.required('Введите пароль')]"
            dense
            label="Текущий пароль"
            single-line
            required
            outlined
            v-model="pass"
            prepend-inner-icon="mdi-lock-outline"
            :type="show ? 'text' : 'password'"
          >
            <template #append>
              <v-icon @click="show = !show" tabindex="-1" v-if="show">mdi-eye</v-icon>
              <v-icon @click="show = !show" tabindex="-1" v-else>mdi-eye-off</v-icon>
            </template>
          </v-text-field>
        </v-col>
      </v-row>

      <v-row class="mb-3" dense align="center" v-if="showChangePhoneForm">
        <v-col offset="0" offset-sm="3" cols="12">
          <v-btn class="mr-2" :disabled="!newPhoneValid" color="primary" @click="send">Сохранить</v-btn>
          <v-btn text @click="resetPhone">Отмена</v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-form>
      <v-row class="mb-3" dense align="center">
        <v-col cols="12" sm="3" class="font font--color_light">{{ showPass ? "Текущий пароль" : "Пароль" }}</v-col>
        <v-col cols="12" sm="9">
          <v-text-field
            autofocus
            v-if="showPass"
            hide-details
            :rules="[rule.required('Введите пароль')]"
            dense
            label="Текущий пароль"
            single-line
            required
            outlined
            v-model="pass"
            prepend-inner-icon="mdi-lock-outline"
            :type="show3 ? 'text' : 'password'"
          >
            <template #append>
              <v-icon @click="show3 = !show3" tabindex="-1" v-if="show3">mdi-eye</v-icon>
              <v-icon @click="show3 = !show3" tabindex="-1" v-else>mdi-eye-off</v-icon>
            </template>
          </v-text-field>
          <a v-else href="#" @click.prevent="openNewPass" class="font">изменить</a>
        </v-col>
      </v-row>

      <v-row class="mb-3" v-if="showPass" dense align="center">
        <v-col cols="12" sm="3" class="font font--color_light">Новый пароль</v-col>
        <v-col cols="12" sm="9">
          <div style="position: relative">
            <PwdTip
              position="top"
              :value="showPwdtip"
              :isdigit="isdigit"
              :islower="islower"
              :ismin="ismin"
              :isupper="isupper"
            />
            <v-text-field
              single-line
              hide-details
              dense
              required
              outlined
              v-model="newpass"
              :rules="[rule.notRussian, rule.min, rule.upper, rule.lower, rule.digit]"
              :type="show1 ? 'text' : 'password'"
              name="pwd1"
              label="Новый пароль"
              @update:error="updateValid"
              @focus="showPwdtip = true"
              @blur="showPwdtip = false"
            >
              <template #append>
                <v-icon @click="show1 = !show1" tabindex="-1" v-if="show1">mdi-eye</v-icon>
                <v-icon @click="show1 = !show1" tabindex="-1" v-else>mdi-eye-off</v-icon>
              </template>
            </v-text-field>
          </div>
        </v-col>
      </v-row>

      <v-row class="mb-3" v-if="showPass" dense align="center">
        <v-col cols="12" sm="3" class="font font--color_light">Повторите пароль</v-col>
        <v-col cols="12" sm="9">
          <v-text-field
            dense
            hide-details
            :disabled="!valid"
            single-line
            required
            outlined
            v-model="confirm"
            :rules="[rule.same]"
            :type="show2 ? 'text' : 'password'"
            name="pwd2"
            label="Повторите пароль"
          >
            <template #append>
              <v-icon @click="show2 = !show2" tabindex="-1" v-if="show2">mdi-eye</v-icon>
              <v-icon @click="show2 = !show2" tabindex="-1" v-else>mdi-eye-off</v-icon>
            </template>
          </v-text-field>
        </v-col>
      </v-row>

      <v-row class="mb-3" v-if="showPass" dense align="center">
        <v-col offset="0" offset-sm="3" cols="12">
          <v-btn :disabled="!valid || newpass !== confirm" color="primary" class="mr-2" @click="sendChangePass"
            >Изменить</v-btn
          >
          <v-btn @click="resetPass" text>Отмена</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { mask } from "vue-the-mask";
import { email as ruleEmail } from "@/utils/rules";
import MaskedTextField from "@/components/common/MaskedTextField";
import PwdTip from "@/components/common/PwdTip";
import { formatPhone } from "@/mixins/formatPhone";

export default {
  components: { MaskedTextField, PwdTip },
  directives: { mask },
  mixins: [formatPhone],

  props: {
    module: {
      type: String,
    },
  },

  data() {
    return {
      valid: false,
      show: false,
      show1: false,
      show2: false,
      show3: false,
      showPwdtip: false,
      confirm: "",
      newPhoneValid: false,
      nameValid: false,
      middleName: "",
      secondName: "",
      firstName: "",
      emailName: "",
      rule: {
        min: (v) => v.length >= 6 || "Минимум 6 символов",
        notRussian: (v) => !/[А-Я]|[а-я]|\s/.test(v) || "Без пробелов и букв русского алфавита",
        upper: (v) => /[A-Z]/.test(v) || "Одна заглавная латинская буква",
        lower: (v) => /[a-z]/.test(v) || "Одна строчная латинская буква",
        digit: (v) => /\d/.test(v) || "Одна цифра",
        same: (v) => v === this.newpass || "Пароли не совпадают",
        required: (msg) => (v) => !!v || msg,
        email: ruleEmail,
        phone: (v) => v.replace(/\D/g, "").length === 11 || "Введите номер телефона",
      },
    };
  },

  mounted() {
    this.firstName = this.first;
    this.secondName = this.second;
    this.middleName = this.middle;
    this.emailName = this.email;
  },

  watch: {
    code(code, oldCode) {
      if (code.length === 4 && oldCode.length < 4) {
        this.send();
      }

      if (this.errdesc.length > 0) {
        this.clearErrdesc();
      }
    },
    first(v) {
      this.firstName = v;
    },
    second(v) {
      this.secondName = v;
    },
    middle(v) {
      this.middleName = v;
    },
    email(v) {
      this.emailName = v;
    },
    // currentTime(time) {
    //   if (time === 0) {
    //     this.stopTimer();
    //   }
    // },
  },
  methods: {
    ...mapActions("common", ["clearErrdesc"]),
    ...mapMutations("user_transfer", ["setPhoneForm"]),
    updateValid(e) {
      this.valid = !e;
    },
    send() {
      this.$store.dispatch("user/changeLogin");
    },
    sendChangePass() {
      this.$store.dispatch("user/changePass");
      this.confirm = "";
    },
    async updateName() {
      const data = {};
      if (this.isFirstNameChanged) {
        data.firstname = this.firstName;
      }
      if (this.isSecondNameChanged) {
        data.surname = this.secondName;
      }
      if (this.isMiddleNameChanged) {
        data.middlename = this.middleName;
      }
      if (this.isEmailChanged) {
        data.email = this.emailName;
      }
      const res = await this.$store.dispatch("profile/updateProfile", data);
      if (res) {
        this.firstName = this.first;
        this.secondName = this.second;
        this.middleName = this.middle;
        this.emailName = this.email;
      }
    },
    resetName() {
      this.middleName = this.middle;
      this.secondName = this.second;
      this.firstName = this.first;
      this.emailName = this.email;
    },
    openNewPhone() {
      if (this.isTransfered) {
        this.showPhone = true;
        this.resetPass();
      } else {
        this.setPhoneForm(true);
      }
    },
    resetPhone() {
      this.$refs.newPhoneForm.resetValidation();
      this.$store.dispatch("user/resetPhoneChange");
    },
    openNewPass() {
      if (this.isTransfered) {
        this.showPass = true;
        this.resetPhone();
      } else {
        this.setPhoneForm(true);
      }

    },
    resetPass() {
      this.$store.dispatch("user/resetPassChange");
      this.confirm = "";
    },
  },

  computed: {
    ...mapGetters("common", ["errdesc"]),
    ...mapGetters("profile", ["isTransfered"]),
    ismin() {
      return this.rule.min(this.newpass) === true && this.rule.notRussian(this.newpass) === true;
    },
    isupper() {
      return this.rule.upper(this.newpass) === true;
    },
    islower() {
      return this.rule.lower(this.newpass) === true;
    },
    isdigit() {
      return this.rule.digit(this.newpass) === true;
    },
    showChangePhoneForm() {
      return this.showPhone && this.process === "init";
    },
    showConfirmCodeForm() {
      return this.showPhone && this.process === "apply";
    },
    isFirstNameChanged() {
      return this.first !== this.firstName;
    },
    isSecondNameChanged() {
      return this.second !== this.secondName;
    },
    isMiddleNameChanged() {
      return this.middle !== this.middleName;
    },
    isEmailChanged() {
      return this.email !== this.emailName;
    },
    isNameOrEmailChanged() {
      return this.isFirstNameChanged || this.isSecondNameChanged || this.isMiddleNameChanged || this.isEmailChanged;
    },
    first: {
      get() {
        return this.$store.state.profile.firstname;
      },
      set(value) {
        this.$store.commit("profile/set", { type: "firstname", value });
      },
    },
    second: {
      get() {
        return this.$store.state.profile.surname;
      },
      set(value) {
        this.$store.commit("profile/set", { type: "surname", value });
      },
    },
    middle: {
      get() {
        return this.$store.state.profile.middlename;
      },
      set(value) {
        this.$store.commit("profile/set", { type: "middlename", value });
      },
    },
    email: {
      get() {
        return this.$store.state.profile.email;
      },
      set(value) {
        this.$store.commit("profile/set", { type: "email", value });
      },
    },
    pass: {
      get() {
        return this.$store.state.user.pass;
      },
      set(value) {
        this.$store.commit("user/set", { type: "pass", value });
      },
    },
    phone() {
      return this.$store.state.profile.phone;
    },
    process() {
      return this.$store.state.user.process;
    },
    newphone: {
      get() {
        return this.$store.state.user.newphone;
      },
      set(value) {
        this.$store.commit("user/set", { type: "newphone", value });
      },
    },
    showPhone: {
      get() {
        return this.$store.state.user.showPhone;
      },
      set(value) {
        this.$store.commit("user/set", { type: "showPhone", value });
      },
    },
    newpass: {
      get() {
        return this.$store.state.user.newpass;
      },
      set(value) {
        this.$store.commit("user/set", { type: "newpass", value });
      },
    },
    showPass: {
      get() {
        return this.$store.state.user.showPass;
      },
      set(value) {
        this.$store.commit("user/set", { type: "showPass", value });
      },
    },
    code: {
      get() {
        return this.$store.state.user.code;
      },
      set(value) {
        this.$store.commit("user/set", { type: "code", value });
      },
    },
  },

  beforeDestroy() {
    this.resetPhone();
    this.resetPass();
  },
};
</script>
